import ReviewCartView from "../../../Views/CheckoutV2/ReviewCart/ReviewCartView";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { env } from "../../../env";
import {
  getDateNowInUtc,
  generateTransactionId,
  generateUniqueNumberString,
  calculateOverSeasPrice,
  formatToTwoFractionalDigits,
  getToFixeValue,
  isDateWithinNextTwoDays,
  removePastDatesByNameAndDate,
  getUpcomingDate,
  getDateFormatedForPujaDetails,
  getNormalizedDateTime,
  generateOrderId,
  calculateChadhavaPriceDataForSubscription,
  calculateDiscountedPrice,
  truncateToTwoDecimals,
  scaleObjectValues,
  isValidDate,
  getDeviceInfo,
} from "../../../utils/HelperFunctions";
import { OrderService, CommonService, CouponService } from "td_server/services";
import {
  setPujaMembers,
  setSelectedPuja,
  setSelectedTempleDetailsForPuja,
} from "../../../store/slices/pujaSlice";
import {
  addAndUpdateCartItem,
  emptyCartAction,
  removeItemFromCartAction,
  updateCartAction,
  updateTempCartPayloadAction,
} from "../../../store/actions/cartAction";
import { setSelectedAddressInCart } from "../../../store/slices/cartSlice";
import {
  generateRazorPayOrderId,
  placeOrderAction,
} from "../../../store/actions/orderAction";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import successIcon from "../../../assets/success.png";
import errorIcon from "../../../assets/error.png";
import CartNoItem from "../../../components/card/Cart/NoItemInCart";
import { updateCouponsUsageAction } from "../../../store/actions/CouponCodeAction";
import templeLogo from "../../../assets/temple-logo-icon.png";
import { addAnalytics } from "../../../store/actions/AnalyticsAction";
import { LOCALSTORAGE_KEY, orderType } from "../../../utils/Constants";
import { setSelectedAddressId } from "../../../store/slices/userSlice";
import BookingDateConfirmDialog from "../../../components/dialog/BookingDateConfirmDialog";
import { LOCALIZATION } from "../../../utils/localization";
import { t } from "i18next";
import {
  getPriceInfoOfPujaAndPackageV1,
  getPujaPackagePriceAction,
} from "../../../store/actions/pujaAction";
import { getPriceInfoOfPujaAndPackage } from "../../../store/actions/templeAction";
import { setOrderList } from "../../../store/slices/orderSlice";
import { getTotalPrasadPrice } from "../../../store/actions/prasadAction";
import DelivaryWeightConfirmationDialog from "../../../components/dialog/DelivaryWeightConfirmationDialog";
import AlertDialog from "../../../components/dialog/AlertDialog";
import {
  getOrderDisplayName,
  trackPurchase,
  getOrderQuantity,
} from "../../../utils/googleAnalytics";
import {
  getTotalCartPrice,
  trackCleavertapEvent,
  getOrderQuantityClertap,
} from "../../../utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "../../../utils/analyics/analyticsEvents";
import { CART_INACTIVITY_TIMEOUT } from "../../../utils/analyics/analyticsConstant";

function ReviewCartScreen() {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // REFS

  const pageStartTimeRef = useRef<number | null>(null);
  const cartTrackingRef = useRef<any>({
    startedAt: Date.now(),
    abandonFired: false,
    paymentStarted: false,
    paymentSuccess: false,
  });
  const prevCartRef = useRef<any>(null);
  const cartTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // states
  const [chooseAddressBox, setChooseAddressBox] = useState(false);
  const [orderCreatedScreen, setOrderCreatedScreen] = useState(false);
  const [orderResultDetails, setOrderResultDetails] = useState("");
  const { cartInfo, selectedAddressInCart } = useSelector(
    (state: any) => state.cart,
  );

  const [errorPopup, setErrorPopUp]: any = useState({
    isError: false,
    errorMessages: [],
  });
  const [bookingFailedPopup, setBookingFailedPopUp]: any = useState(false);
  const [couponPopup, setCouponPopUp]: any = useState(false);
  const [selectedCartItem, setSelectedCartItem]: any = useState(null);
  const [allActiveCoupons, setAllActiveCoupons] = useState<any>([]);
  const [panditDakshina, setPanditDakshina] = useState<number>(0);
  const [showDeliveryAlert, setShowDeliveryAlert] = useState(false);
  const [bookingDateConfirmDialogOpen, setBookingDateConfirmDialogOpen] =
    useState<boolean>(false);
  const [bookingDateInConfirmDialog, setbookingDateInConfirmDialog] =
    useState<string>("");
  const [newDateDateInConfirmDialog, setNewDateDateInConfirmDialog] =
    useState<string>("");
  const [
    isBookingConfirmedOnUpcomingDate,
    setIsBookingConfirmedOnUpcomingDate,
  ] = useState<boolean>(false);
  const [outSideIndiaMessagePopup, setOutSideIndiaMessagePopup] =
    useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  // For package
  const [isPrasadPkgOpen, setIsPrasadPkgOpen] = useState<any>(false);
  const [selectedPrasadItem, setSelectedPrasadItem] = useState<any>(null);
  const [isOverweight, setIsOverweight] = useState<boolean>(false);
  const [isOverLimit, setIsOverLimit] = useState<boolean>(false);
  const [selectedChadhavaSubscription, setSelectedChadhavaSubscription] =
    useState<any>(null);
  // Only summary price info for subscription chadhavas only without subscription
  const [subscriptionChadhavaAggPrice, setSubscriptionChadhavaAggPrice] =
    useState<any>(null);
  const [selectedPujaSubscription, setSelectedPujaSubscription] =
    useState<any>(null);
  const [singlePujaPrice, setSinglePujaPrice] = useState<any>(null);
  useEffect(() => {
    if (couponPopup) {
      // setIsPackageCouponCode(false);
    }
  }, [couponPopup]);

  const [chadhavaList, setChadhavaList] = useState<any>([]);

  const { templeChadhavaList } = useSelector((state: any) => state.chadhawa);
  const { templePrasadList } = useSelector((state: any) => state.prasad);

  // const [ selectedCartItemData,setSelectedCartItemData] = useState<any>(null)

  useEffect(() => {
    if (cartInfo && location) {
      const queryParams = new URLSearchParams(location.search);

      // Get individual query parameters
      const cartItemId = queryParams.get("cartId");
      let selectedCartItemRes = cartInfo.filter(function (item: any) {
        return item?.cartId === cartItemId;
      });

      if (selectedCartItemRes && selectedCartItemRes.length > 0) {
        setSelectedCartItem(selectedCartItemRes[0]);

        dispatch(updateTempCartPayloadAction(selectedCartItemRes[0]));
        if (
          selectedCartItemRes[0]?.orderType === orderType.chadhava &&
          selectedCartItemRes[0]?.isSubscribed
        ) {
          setSelectedChadhavaSubscription(
            selectedCartItemRes[0]?.currentSubscriptionPlan || null,
          );
        }
        if (
          selectedCartItemRes[0]?.orderType === orderType.puja &&
          selectedCartItemRes[0]?.isSubscribed
        ) {
          setSelectedPujaSubscription(
            selectedCartItemRes[0]?.currentSubscriptionPlan || null,
          );
        }
      } else {
        if (cartInfo?.length > 0) {
          setSelectedCartItem(cartInfo[0]);
          dispatch(updateTempCartPayloadAction(cartInfo[0]));
        }
      }
    }
  }, [cartInfo, location, cartInfo?.length]);

  useEffect(() => {
    if (
      selectedCartItem &&
      selectedCartItem?.orderType === orderType.chadhava
    ) {
      if (templeChadhavaList?.length > 0) {
        const updatedResponse = templeChadhavaList.map((item: any) => ({
          ...item,
          count: 0,
        }));
        setChadhavaList(updatedResponse);
        //setChadhavaList(templeChadhavaList);
      }
    }
  }, [templeChadhavaList]);

  // Place order upon suggesting new booking date:

  useEffect(() => {
    if (isBookingConfirmedOnUpcomingDate) {
      placeOrder();
    }
  }, [isBookingConfirmedOnUpcomingDate]);

  useEffect(() => {
    if (selectedCartItem && selectedCartItem?.orderType === orderType.prasad) {
      if (templePrasadList?.length > 0) {
        const updatedResponse = templePrasadList.map((item: any) => ({
          ...item,
          count: 0,
          disabled: false,
        }));
        setChadhavaList(updatedResponse);
      }
    }
  }, [templePrasadList]);

  // useEffect(() => {
  //   if (selectedCartItem?.templeDetails?.id) {

  //     dispatch(getChadhavaForTempleList(selectedCartItem.templeDetails.id));
  //     //getChadhavaForTemple(templeId);
  //   }
  // }, [selectedCartItem?.templeDetails?.id]);

  // const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponApplyResponse, setCouponApplyResponse] = useState<any>({
    isValid: false,
    isApplied: false,
    finalPrice: 0,
    couponData: null,
    isError: false,
    errorDetails: "",
    actualPujaPrice: 0,
    discount: 0,
    gst: 0,
    priceBreakup: {},
  });
  const [couponCodeData, setCouponCodeData]: any = useState("");
  const [priceBreakupData, setPriceBreakupData]: any = useState({
    actualPujaPrice: 0,
    gst: 0,
    finalPrice: 0,
    finalPriceOv: 0,
    priceBreakup: null,
  });
  const [previousPriceData, setPreviousPriceData]: any = useState("");
  const [avialableCouponCode, setAvailableCouponCode]: any = useState(null);
  const { selectedPuja, selectedTempleDetailsForPuja, pujaMembers } =
    useSelector((state: any) => state.puja);

  var { userInfo, selectedAddressId } = useSelector((state: any) => state.user);
  const [openChooseAddressBoxForPrasad, setOpenChooseAddressBoxForPrasad] =
    useState<boolean>(false);

  const userPersonalInfo =
    userInfo && userInfo.personalInfo ? userInfo.personalInfo : {};
  const pujaDetails = selectedCartItem ? selectedCartItem.pujaDetails : null;
  const templeDetails = selectedCartItem
    ? selectedCartItem.templeDetails
    : null;
  const pujaPackage = selectedCartItem ? selectedCartItem.pujaPackage : null;
  const memberDetails = selectedCartItem ? selectedCartItem.membersData : [];
  const windowRefrence: any = window;

  const [currencySign, setCurrencySign] = useState<string>("₹");
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion,
  );
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
    currencyCode = "INR",
    countryCode = null,
  } = priceConversionState.priceConversionRate || {};
  const [isPrasad, setIsPrasad] = useState<boolean>(false);
  const getOverSeasPriceByRateText = (
    inrPrice: number,
    isToConvertPrice = false,
  ) => {
    if (selectedCartItem?.orderType === orderType.prasad) {
      return `₹${inrPrice}`;
    }
    return `${currencySymbols}${
      isToConvertPrice ? inrPrice : calculateOverSeasPrice(inrPrice, rate)
    }`;
  };
  const getSymbolWithPrice = (priceValue: any) => {
    if (selectedCartItem?.orderType === orderType.prasad) {
      return `₹${priceValue}`;
    } else {
      return `${currencySymbols}${priceValue}`;
    }
  };
  useEffect(() => {
    if (selectedCartItem?.orderType === orderType.prasad) {
      setCurrencySign("₹");
    } else {
      setCurrencySign(currencySymbols);
    }
  }, [currencySymbols]);

  // useEffect(()=>{
  //   if(isPrasad && isOverseas){
  //     setChooseAddressBox(true)
  //   }
  // },[isPrasad,isOverseas])

  useEffect(() => {
    if (env === "prod") {
      windowRefrence?.fbq("track", "AddToCart");
    }
    // setSelectedCartItem(selectedCartItem);
    if (userPersonalInfo.address && userPersonalInfo.address.length > 0) {
      let selectedUserAddress: any = null;
      if (selectedCartItem?.orderType !== orderType.puja) {
        selectedUserAddress = userPersonalInfo?.address?.filter(
          (item: any) =>
            item?.id === selectedAddressId && item?.countryCode == "IN",
        );
      } else {
        selectedUserAddress = userPersonalInfo?.address?.filter(
          (item: any) => item.id === selectedAddressId && item?.countryCode,
        );
      }

      //debugger;
      // const selectedUserAddress = userPersonalInfo?.address?.filter(
      //   (item: any) =>
      //     item?.id === selectedAddressId && item?.countryCode == "IN"
      // );
      if (selectedUserAddress) {
        dispatch(setSelectedAddressInCart(selectedUserAddress[0]));
      }
      if (!selectedAddressId) {
        const addressWith = userPersonalInfo?.address?.filter(
          (item: any) => item?.countryCode,
        );
        if (addressWith.length > 0) {
          dispatch(setSelectedAddressInCart(userPersonalInfo?.address[0]));
          localStorage.setItem(
            "selectedAddressId",
            userPersonalInfo?.address[0]?.id,
          );
          dispatch(setSelectedAddressId(userPersonalInfo?.address[0]?.id));
        }
      }
    }

    if (selectedCartItem) {
      if (selectedCartItem?.isPrasad) {
        setIsPrasad(true);
      }
    }
  }, [selectedCartItem, userPersonalInfo]);

  useEffect(() => {
    if (
      selectedCartItem &&
      [
        orderType.chadhava,
        orderType.prasad,
        orderType.pujaPackage,
        orderType.chadhavaPackage,
      ].includes(selectedCartItem?.orderType)
    ) {
      setCouponApplyResponse({
        ...couponApplyResponse,
        isApplied: false,
        isValid: false,
      });
      setPriceQuoteForChadhava();
    }
  }, [selectedCartItem]);

  // useEffect(() => {
  //   CouponService.getAllActiveCouponsByDate().then((res: any) => {
  //     setAllActiveCoupons(res?.couponList);
  //   });
  // }, []);

  useEffect(() => {
    if (allActiveCoupons && allActiveCoupons.length > 0) {
      //let couponData = allActiveCoupons?.filter((item: any) => item?.shouldBeAutoApply === true)[0];
      let couponData = allActiveCoupons[0];
      if (couponData) {
        checkValidityOfcoupon(couponData.couponCode);
      }
    }
  }, [allActiveCoupons]);

  useEffect(() => {
    if (selectedCartItem) {
      if (
        [
          orderType.chadhava,
          orderType.prasad,
          orderType.pujaPackage,
          orderType.chadhavaPackage,
        ]?.includes(selectedCartItem?.orderType)
      ) {
        if (couponApplyResponse.isApplied) {
          setPriceQuoteForChadhavaWithCouponData(couponApplyResponse);
        } else {
          setPriceQuoteForChadhava();
        }
      } else {
        if (couponApplyResponse.isApplied) {
          setPriceQuoteForPujaWithCouponData(couponApplyResponse);
        } else {
          setPriceQuoteForPuja();
        }
      }
    }
  }, [couponApplyResponse, selectedCartItem]);

  useEffect(() => {
    if (selectedCartItem && priceConversionState.priceConversionRate) {
      if (
        [
          orderType.chadhava,
          orderType.prasad,
          orderType.chadhavaPackage,
          orderType.pujaPackage,
        ]?.includes(selectedCartItem?.orderType)
      ) {
        setPriceQuoteForChadhava();
      } else {
        setPriceQuoteForPuja();
      }
    }
  }, [isPrasad, priceConversionState?.priceConversionRate]);

  //  useEffect(() => {
  //   if (selectedCartItem) {
  //     if (selectedCartItem?.orderType === orderType.chadhava) {
  //       if (couponApplyResponse.isApplied) {
  //         setPriceQuoteForChadhavaWithCouponData(couponApplyResponse);
  //       }
  //     } else {
  //       if (couponApplyResponse.isApplied) {
  //         setPriceQuoteForPujaWithCouponData(couponApplyResponse);
  //       }
  //     }
  //   }

  //  }, [priceBreakupData])

  const fetchCouponForPuja = async (
    templeDetails: any,
    pujaDetails: any,
    pujaPackage: any,
  ) => {
    let couponsList: any = [];
    if (templeDetails && pujaDetails) {
      let response1 = await CouponService.getActiveCouponsByPujaIdCurrentDate(
        templeDetails?.id,
        pujaDetails?.pujaId,
        pujaPackage?.packageId,
      );
      if (response1?.couponList && response1?.couponList?.length > 0) {
        couponsList = response1.couponList;
      }
    }

    let response3 = await CouponService.getAllActiveCouponsByDate();
    if (response3?.couponList && response3?.couponList?.length > 0) {
      couponsList = [...couponsList, ...response3.couponList];
      setAllActiveCoupons(couponsList);
    } else {
      couponsList = [...couponsList];
      setAllActiveCoupons(couponsList);
    }

    if (
      couponsList.length > 0 &&
      couponsList.length > avialableCouponCode?.length
    ) {
      setAvailableCouponCode(couponsList[0]);
    }
  };

  useEffect(() => {
    if (!userInfo?.phoneNumber) return;
    if (templeDetails && pujaDetails && !selectedCartItem?.isSubscribed) {
      fetchCouponForPuja(templeDetails, pujaDetails, pujaPackage);
    }
  }, [templeDetails, pujaDetails, pujaPackage, userInfo?.phoneNumber]);

  useEffect(() => {
    if (avialableCouponCode) {
      checkValidityOfcoupon(avialableCouponCode?.couponCode);
      setCouponCodeData(avialableCouponCode?.couponCode);
    }
  }, [avialableCouponCode]);

  useEffect(() => {
    const isAddressInIndia =
      selectedAddressInCart?.countryCode === "IN" ||
      typeof selectedAddressInCart?.countryCode === "undefined" ||
      selectedAddressInCart?.countryCode === null;
    if (isOverseas) {
      setIsPrasad(false);
    } else if (!isOverseas && isAddressInIndia) {
      setIsPrasad(false);
    } else if (!isOverseas && !isAddressInIndia) {
      setIsPrasad(false);
    }
  }, [
    priceConversionState.priceConversionRate,
    selectedAddressInCart,
    isOverseas,
  ]);

  const setPriceQuoteForPuja = async () => {
    if (
      [orderType.chadhava, orderType.prasad]?.includes(
        selectedCartItem?.orderType,
      )
    ) {
      return;
    }
    dispatch(
      getPriceInfoOfPujaAndPackageV1(
        pujaDetails,
        templeDetails?.id,
        selectedCartItem?.selectedPujaPackage?.packageId,
        isOverseas,
        isPrasad,
      ),
    )
      .then((response: any) => {
        if (
          selectedCartItem?.isSubscribed &&
          selectedPujaSubscription?.subscriptionId
        ) {
          // here kept single puja Price
          setSinglePujaPrice(response);
          const newPrice: any = scaleObjectValues(
            response,
            selectedPujaSubscription?.frequency,
          );
          const discountedPrice = {
            ...newPrice,
            offerActualPrice: newPrice?.finalPrice,
            finalPrice: truncateToTwoDecimals(
              calculateDiscountedPrice(
                newPrice?.finalPrice,
                Number(selectedPujaSubscription?.fixDiscount),
              ),
            ),
          };
          setPriceBreakupData(discountedPrice);
          setPreviousPriceData(discountedPrice?.finalPrice);

          return;
        }
        setPriceBreakupData(response);
        setPreviousPriceData(response?.finalPrice);
      })
      .catch((error: any) => {});
  };
  const setPriceQuoteForPujaWithCouponData = (couponApplyResponse: any) => {
    if (couponApplyResponse && couponApplyResponse.priceBreakup) {
      setPriceBreakupData({
        ...couponApplyResponse,
      });
    }
  };

  const setPriceQuoteForChadhavaWithCouponData = (couponApplyResponse: any) => {
    if (couponApplyResponse && couponApplyResponse.priceBreakup) {
      const priceData = {
        ...couponApplyResponse,
        finalPrice:
          Number(couponApplyResponse.finalPrice) + Number(panditDakshina),
        actualFinalPrice: Number(couponApplyResponse.finalPrice),
      };
      setPriceBreakupData({
        ...priceData,
      });
    }
  };

  const calculateTotalPrice = async () => {
    try {
      let totalPrices: any;
      // prasad total pricecalculation service call
      if (selectedCartItem?.orderType === orderType.prasad) {
        totalPrices = await dispatch(
          getTotalPrasadPrice(
            selectedCartItem?.selectedPrasadPackage,
            isOverseas,
            selectedCartItem?.templeDetails?.prasadDelivaryPrice ?? null,
            selectedCartItem?.templeDetails?.prasadPackagingPrice ?? null,
            selectedCartItem?.templeDetails?.prasadGoodiesPrice ?? null,
            rate,
          ),
        );

        if (totalPrices) {
          totalPrices.chadhavaValueItemFinal = totalPrices?.finalPrice;
          totalPrices.chadhavaValueItemFinalOv = totalPrices?.finalPriceOv ?? 0;
          setPriceBreakupData(totalPrices);
          return totalPrices;
        }
      }
      if (selectedCartItem?.orderType === orderType.chadhava) {
        // Chadhava calculation for chadhava subscription
        if (
          selectedCartItem?.isSubscribed &&
          selectedChadhavaSubscription?.subscriptionId
        ) {
          const aggChadhavaPriceData =
            calculateChadhavaPriceDataForSubscription(
              selectedCartItem?.subscriptionChadhavas,
            );
          setSubscriptionChadhavaAggPrice(aggChadhavaPriceData);
          const finalpriceBeforeDiscount =
            calculateChadhavaPriceDataForSubscription(
              selectedCartItem?.subscriptionChadhavas,
              Number(selectedChadhavaSubscription?.frequency),
            );
          const finalPrice = truncateToTwoDecimals(
            calculateDiscountedPrice(
              finalpriceBeforeDiscount?.finalPrice,
              Number(selectedChadhavaSubscription?.fixDiscount),
            ),
          );
          const finalPriceOv = truncateToTwoDecimals(
            calculateDiscountedPrice(
              finalpriceBeforeDiscount?.finalPriceOv,
              Number(selectedChadhavaSubscription?.fixDiscount),
            ),
          );
          const chadhavaValueItemFinal = truncateToTwoDecimals(
            calculateDiscountedPrice(
              finalpriceBeforeDiscount?.chadhavaValueItemFinal,
              Number(selectedChadhavaSubscription?.fixDiscount),
            ),
          );
          const chadhavaValueItemFinalOv = truncateToTwoDecimals(
            calculateDiscountedPrice(
              finalpriceBeforeDiscount?.chadhavaValueItemFinalOv,
              Number(selectedChadhavaSubscription?.fixDiscount),
            ),
          );
          const finalpriceBeforeDiscountWithSubscription = {
            ...finalpriceBeforeDiscount,
            finalPrice: finalPrice + Number(panditDakshina),
            finalPriceOv:
              Number(
                Number(
                  finalPriceOv +
                    Number(
                      calculateOverSeasPrice(Number(panditDakshina), rate),
                    ),
                ).toFixed(2),
              ) || 0,
            chadhavaValueItemFinal: chadhavaValueItemFinal,
            chadhavaValueItemFinalOv: chadhavaValueItemFinalOv,
            priceBreakup: {
              ...finalpriceBeforeDiscount?.priceBreakup,
              dakshina: Number(panditDakshina) || 0,
            },
          };
          setPriceBreakupData(finalpriceBeforeDiscountWithSubscription);
          return finalpriceBeforeDiscountWithSubscription;
        }
        const selectedChadhvaList =
          selectedCartItem?.selectedChadhavaPackage?.filter(
            (item: any) => item?.count > 0,
          );
        totalPrices = selectedChadhvaList?.reduce(
          (totals: any, item: any) => {
            const finalPrice = Number(item.priceInfo.finalPrice) * item.count;
            const calculatedPrice =
              Number(item.priceInfo.calculatedPrice) * item.count;
            const basePrice = Number(item.priceInfo.basePrice) * item.count;
            const gst = Number(item.priceInfo.gst) * item.count;
            const platformFee = item.priceInfo.priceBreakup.platformFee
              ? Number(item.priceInfo.priceBreakup.platformFee) * item.count
              : 0;
            const adminCommission = item.priceInfo.priceBreakup.adminCommission
              ? Number(item.priceInfo.priceBreakup.adminCommission) * item.count
              : 0;

            const finalPriceOv = Number(
              item.count * Number(item?.priceInfo?.finalPriceOv),
            ).toFixed(2);

            totals.finalPriceTotal += finalPrice;
            totals.calculatedPriceTotal += calculatedPrice;
            totals.gstTotal += gst;
            totals.basePrice += basePrice;
            totals.platformFee += platformFee;
            totals.adminCommission += adminCommission;

            totals.finalPriceOv += Number(finalPriceOv);

            return totals;
          },
          {
            finalPriceTotal: 0,
            calculatedPriceTotal: 0,
            gstTotal: 0,
            basePrice: 0,
            platformFee: 0,
            adminCommission: 0,
            finalPriceOv: 0,
          },
        );
        const priceData = {
          actualPujaPrice: totalPrices?.calculatedPriceTotal,
          delivery: 0,
          gst: totalPrices?.gstTotal?.toFixed(2) || 0,
          finalPrice:
            Number(totalPrices?.finalPriceTotal) + Number(panditDakshina) || 0,
          calculatedPrice: totalPrices?.calculatedPriceTotal || 0,
          finalPriceOv:
            Number(
              Number(
                totalPrices?.finalPriceOv +
                  Number(calculateOverSeasPrice(Number(panditDakshina), rate)),
              ).toFixed(2),
            ) || 0,
          chadhavaValueItemFinalOv: Number(
            totalPrices?.finalPriceOv?.toFixed(2),
          ),
          chadhavaValueItemFinal: Number(
            totalPrices?.finalPriceTotal?.toFixed(2),
          ),
          priceBreakup: {
            basePrice: Number(totalPrices?.basePrice) || 0,
            delivery: 0,
            packaging: 0,
            goodies: 0,
            adminCommission: Number(totalPrices?.adminCommission) || 0,
            platformFee: Number(totalPrices?.platformFee) || 0,
            dakshina: Number(panditDakshina) || 0,
          },
        };
        setPriceBreakupData(priceData);
        return priceData;
      }
      // Puja Package price
      if (selectedCartItem?.orderType === orderType.pujaPackage) {
        let _priceBreakupV1 = pujaDetails?.priceBreakupV1;
        if (
          selectedCartItem?.isSubscribed &&
          selectedCartItem?.subscriptionId
        ) {
          const filteredPkg =
            selectedCartItem?.pujaDetails?.subscriptions?.find(
              (_pkg: any) => _pkg?.id === selectedCartItem?.subscriptionId,
            );
          if (filteredPkg) {
            _priceBreakupV1 = filteredPkg?.priceBreakupV1;
          }
        }
        totalPrices = await dispatch(
          getPujaPackagePriceAction(
            _priceBreakupV1,
            isOverseas,
            rate,
            isPrasad,
          ),
        );

        if (totalPrices) {
          setPriceBreakupData(totalPrices);
          setPreviousPriceData(totalPrices?.finalPrice);
          return totalPrices;
        }
      }
      // Chadhava Package price
      if (selectedCartItem?.orderType === orderType.chadhavaPackage) {
        let _priceBreakupV1 = pujaDetails?.priceBreakupV1;
        if (
          selectedCartItem?.isSubscribed &&
          selectedCartItem?.subscriptionId
        ) {
          const filteredPkg =
            selectedCartItem?.pujaDetails?.subscriptions?.find(
              (_pkg: any) => _pkg?.id === selectedCartItem?.subscriptionId,
            );
          if (filteredPkg) {
            _priceBreakupV1 = filteredPkg?.priceBreakupV1;
          }
        }
        totalPrices = await dispatch(
          getPujaPackagePriceAction(_priceBreakupV1, isOverseas, rate, false),
        );

        if (totalPrices) {
          totalPrices.finalPrice =
            Number(totalPrices?.finalPrice) + Number(panditDakshina) || 0;
          if (isOverseas) {
            totalPrices.finalPriceOv =
              Number(
                Number(
                  totalPrices?.finalPriceOv +
                    Number(
                      calculateOverSeasPrice(Number(panditDakshina), rate),
                    ),
                ).toFixed(2),
              ) || 0;
          }
          totalPrices.priceBreakup = {
            ...(totalPrices?.priceBreakup ? totalPrices.priceBreakup : {}),
            dakshina: Number(panditDakshina) || 0,
          };
          setPriceBreakupData(totalPrices);
          setPreviousPriceData(totalPrices?.finalPrice);
          return totalPrices;
        }
      }
    } catch (err: any) {}
  };

  // const getChadhavaTotalValue = (item: any) => {
  //   const selectedChadhvaList = selectedCartItem?.selectedChadhvaList?.filter(
  //     (item: any) => item?.count > 0
  //   );
  //   const totalPrices = selectedChadhvaList?.reduce(
  //     (totals: any, item: any) => {
  //       const finalPrice = Number(item.priceInfo.finalPrice) * item.count;
  //       totals.finalPriceTotal += finalPrice;
  //       return totals;
  //     },
  //     { finalPriceTotal: 0 }
  //   );
  //   return isOverseas
  //     ? priceBreakupData?.chadhavaValueItemFinalOv
  //     : totalPrices?.finalPriceTotal || 0;
  // };

  // const getChadhavaFinalPaymentValue = (item = {}) => {
  //   const selectedChadhvaList = selectedCartItem?.selectedChadhvaList?.filter(
  //     (item: any) => item?.count > 0
  //   );
  //   const totalPrices = selectedChadhvaList?.reduce(
  //     (totals: any, item: any) => {
  //       const finalPrice = Number(item.priceInfo.finalPrice) * item.count;
  //       totals.finalPriceTotal += finalPrice;
  //       return totals;
  //     },
  //     { finalPriceTotal: 0 }
  //   );
  //   return isOverseas
  //     ? priceBreakupData?.finalPriceOv
  //     : totalPrices?.finalPriceTotal || 0;
  // };

  const getChadhavaTotalValue = (item: any) => {
    // const selectedChadhvaList = selectedCartItem?.selectedChadhvaList?.filter(
    //   (item: any) => item?.count > 0
    // );
    // const totalPrices = selectedChadhvaList?.reduce(
    //   (totals: any, item: any) => {
    //     const finalPrice = Number(item.priceInfo.finalPrice) * item.count;
    //     totals.finalPriceTotal += finalPrice;
    //     return totals;
    //   },
    //   { finalPriceTotal: 0 }
    // );
    // return isOverseas
    //   ? priceBreakupData?.chadhavaValueItemFinalOv
    //   : totalPrices?.finalPriceTotal || 0;

    if (selectedCartItem?.orderType === orderType.prasad) {
      return priceBreakupData?.chadhavaValueItemFinal;
    }
    return isOverseas
      ? priceBreakupData?.chadhavaValueItemFinalOv
      : priceBreakupData?.chadhavaValueItemFinal;
  };

  const getChadhavaFinalPaymentValue = (item = {}) => {
    // const selectedChadhvaList = selectedCartItem?.selectedChadhvaList?.filter(
    //   (item: any) => item?.count > 0
    // );
    // const totalPrices = selectedChadhvaList?.reduce(
    //   (totals: any, item: any) => {
    //     const finalPrice = Number(item.priceInfo.finalPrice) * item.count;
    //     totals.finalPriceTotal += finalPrice;
    //     return totals;
    //   },
    //   { finalPriceTotal: 0 }
    // );
    if (selectedCartItem?.orderType === orderType.prasad) {
      return priceBreakupData?.finalPrice || 0;
    }
    return isOverseas
      ? priceBreakupData?.finalPriceOv
      : Math.round(priceBreakupData?.finalPrice || 0);
  };

  useEffect(() => {
    calculateTotalPrice();
    // const selectedChadhvaList = selectedCartItem?.selectedChadhvaList?.filter(
    //   (item: any) => item?.count > 0
    // );
    // const totalPrices = selectedChadhvaList?.reduce(
    //   (totals: any, item: any) => {
    //     const finalPrice =
    //       Math.round(Number(item.priceInfo.finalPrice)) * item.count;
    //     totals.finalPriceTotal += finalPrice;
    //     return totals;
    //   },
    //   { finalPriceTotal: 0 }
    // );

    // let couponDiscount = 0;

    // if (couponApplyResponse && couponApplyResponse?.isApplied) {
    //   // couponDiscount =  couponApplyResponse?.discount
    //   setPriceBreakupData((prevState: any) => ({
    //     ...prevState,
    //     finalPrice:
    //       Number(couponApplyResponse?.finalPrice) + Number(panditDakshina),
    //   }));
    // } else {
    //   setPriceBreakupData((prevState: any) => ({
    //     ...prevState,
    //     finalPrice:
    //       Number(totalPrices?.finalPriceTotal) + Number(panditDakshina),
    //   }));
    // }
  }, [panditDakshina]);

  const setPriceQuoteForChadhava = async () => {
    // const selectedChadhvaList = getSelectedChadhvaList() || [];
    // const totalPrices = selectedChadhvaList?.reduce(
    //   (totals: any, item: any) => {
    //     const finalPrice =
    //       Math.round(Number(item.priceInfo.finalPrice)) * item.count;
    //     const calculatedPrice =
    //       Math.round(Number(item.priceInfo.calculatedPrice)) * item.count;
    //     const gst = Math.round(Number(item.priceInfo.gst)) * item.count;

    //     totals.finalPriceTotal += finalPrice;
    //     totals.calculatedPriceTotal += calculatedPrice;
    //     totals.gstTotal += gst;
    //     return totals;
    //   },
    //   { finalPriceTotal: 0, calculatedPriceTotal: 0, gstTotal: 0 }
    // );

    // const priceData = {
    //   actualPujaPrice: totalPrices?.calculatedPriceTotal,
    //   delivery: 0,
    //   gst: totalPrices?.gstTotal?.toFixed(2),
    //   finalPrice: Number(totalPrices?.finalPriceTotal) + Number(panditDakshina),
    //   priceBreakup: {
    //     basePrice: 0,
    //     delivery: 0,
    //     packaging: 0,
    //     goodies: 0,
    //     adminCommission: 0,
    //     platformFee: 0,
    //   },
    // };
    const priceData: any = await calculateTotalPrice();
    setPriceBreakupData({
      ...priceData,
    });
    setPreviousPriceData(Number(priceData?.finalPrice));
  };

  const changeDeliverytAddress = (address: any) => {
    localStorage.setItem("selectedAddressId", address?.id);
    dispatch(setSelectedAddressId(address?.id));
    dispatch(setSelectedAddressInCart(address));
  };

  const editPujaOptions = (selectedCartItem: any) => {
    dispatch(setSelectedTempleDetailsForPuja(selectedCartItem.templeDetails));
    dispatch(setSelectedPuja(selectedCartItem.pujaDetails));
    dispatch(setPujaMembers(selectedCartItem.membersData));
    dispatch(updateTempCartPayloadAction(selectedCartItem));
    navigate("/checkoutV2/addDevotee");
  };

  const clearCart = (e: any) => {
    try {
      dispatch(
        removeItemFromCartAction(
          userInfo?.phoneNumber,
          selectedCartItem?.cartId,
        ),
      );
      navigate("/temples");
    } catch (err: any) {}
  };

  const checkForAnyFormError = () => {
    let isErrorInForm = false;
    let errorMsg = [];
    if (
      !selectedAddressInCart &&
      [orderType.puja, orderType.prasad, orderType.pujaPackage].includes(
        selectedCartItem?.orderType,
      )
    ) {
      isErrorInForm = true;
      errorMsg.push({
        errType: "addressNotGiven",
        message: t(LOCALIZATION.Address_not_provided),
      });
    }

    if (!isPrasad) {
      isErrorInForm = false;
      errorMsg.push([]);
    }

    if (!memberDetails || memberDetails.length === 0) {
      isErrorInForm = true;
      errorMsg.push({
        errType: "memberNotSelected",
        message: "No members added for puja please add atleast 1 member",
      });
    }

    if (isErrorInForm) {
      setErrorPopUp({ isError: true, errorMessages: errorMsg });
      return false;
    }
    return true;
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const handleBookingConfirm = () => {
    setSelectedCartItem((prev: any) => ({
      ...(prev || {}),
      pujaDateTime: {
        ...(prev?.pujaDateTime || {}),
        pujaDate: `${newDateDateInConfirmDialog} 10:30AM`,
      },
      bookedForDate: {
        pujaDate: `${newDateDateInConfirmDialog} 10:30AM`,
        pujaTime: "10:30AM",
      },
    }));
    setNewDateDateInConfirmDialog("");
    setbookingDateInConfirmDialog("");
    setBookingDateConfirmDialogOpen(false);

    // placeOrder();
    setIsBookingConfirmedOnUpcomingDate(true);
  };
  const handleBookingCancel = () => {
    setNewDateDateInConfirmDialog("");
    setbookingDateInConfirmDialog("");
    setBookingDateConfirmDialogOpen(false);
  };

  const handlePlaceOrder = async (e: any) => {
    e.preventDefault();
    setNewDateDateInConfirmDialog("");
    setbookingDateInConfirmDialog("");
    const _bookingDate = selectedCartItem?.bookedForDate?.pujaDate;
    let bookingDate = getNormalizedDateTime(_bookingDate);
    if (bookingDate && !isDateWithinNextTwoDays(bookingDate)) {
      let newDate = "";
      if (selectedCartItem.orderType === orderType.puja) {
        let removedPastD = removePastDatesByNameAndDate(
          selectedCartItem?.pujaDetails?.restrictionDate,
        );
        if (removedPastD.length > 0) {
          newDate = getUpcomingDate(removedPastD[0]);
        }
      } else if (selectedCartItem.orderType === orderType.chadhava) {
        let removedPastD = removePastDatesByNameAndDate(
          selectedCartItem?.localRestrictionChadavaDate,
        );
        if (removedPastD.length > 0) {
          newDate = getUpcomingDate(removedPastD[0]);
        }
      }
      setbookingDateInConfirmDialog(bookingDate);
      if (isValidDate(newDate)) {
        setNewDateDateInConfirmDialog(newDate);
      }
      setBookingDateConfirmDialogOpen(true);
    } else {
      await placeOrder();
    }
  };

  const handlePlaceOrderV2 = async (e: any) => {
    e.preventDefault();
    const isOverweightDel =
      selectedCartItem?.orderType === orderType.prasad &&
      ((priceBreakupData?.exceedsMaxKg ?? false) ||
        (priceBreakupData?.exceedsMaxMl ?? false));
    if (isOverweightDel) {
      setIsOverweight(true);
    } else {
      await handlePlaceOrder(e);
    }
  };

  const placeOrder = async () => {
    // e.preventDefault();
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    //check for error
    const isFormValid = checkForAnyFormError();
    //error checking complete
    if (isFormValid) {
      // let basePrice = priceDetails.basePrice;
      let orderValue = Math.round(priceBreakupData?.finalPrice);
      const _basePrice = priceBreakupData?.priceBreakup?.basePrice;
      const priceBreakup: any = {
        basic: _basePrice,
        adminCommission: priceBreakupData?.priceBreakup?.adminCommission,
        delivery: priceBreakupData?.priceBreakup?.delivery,
        packaging: priceBreakupData?.priceBreakup?.packaging,
        goodies: priceBreakupData?.priceBreakup?.goodies,
        platformFee: priceBreakupData?.priceBreakup?.platformFee,
        gst: priceBreakupData?.gst,
      };
      if (
        [
          orderType.chadhava,
          orderType.prasad,
          orderType.chadhavaPackage,
        ].includes(selectedCartItem?.orderType)
      ) {
        priceBreakup.dakshina = priceBreakupData?.priceBreakup?.dakshina;
      }

      let razorPayAmount: any = 0;
      let orderValueOv: any = null;

      if (selectedCartItem?.orderType !== orderType.prasad) {
        razorPayAmount =
          currencyCode === "INR"
            ? Number(Number(orderValue))
            : selectedCartItem?.orderType === orderType.chadhava && isOverseas
              ? getChadhavaFinalPaymentValue()
              : Number(
                  calculateOverSeasPrice(Number(orderValue), rate, "number"),
                );

        razorPayAmount = parseFloat((razorPayAmount * 100).toFixed(2));
        orderValueOv =
          currencyCode !== "INR" &&
          selectedCartItem?.orderType === orderType.chadhava &&
          isOverseas
            ? getChadhavaFinalPaymentValue()
            : null;
      } else {
        razorPayAmount = Number(Number(orderValue) * 100);
      }
      const transectionId = generateTransactionId();
      const orderId = generateOrderId(selectedCartItem?.orderType);

      const orderData = {
        amount: razorPayAmount.toString(),
        currency:
          selectedCartItem?.orderType === orderType.prasad
            ? "INR"
            : currencyCode,
        receipt: "receipt#1",
        notes: {
          key1: orderId,
          key2: userInfo?.phoneNumber,
          key3: env,
        },
      };

      try {
        await dispatch(generateRazorPayOrderId(orderData)).then(
          async (rpOrderIdResponse: any) => {
            trackCleavertapEvent(ANALYTICS_EVENTS.Payment_Initiated, {
              User_ID: userInfo?.id ?? "Guest User",
              Order_ID: orderId,
              Transaction_ID: transectionId,
              Amount:
                truncateToTwoDecimals(rpOrderIdResponse?.amount / 100) ?? 0,
              Currency: currencyCode,
              IsOverseas: isOverseas,
              Order_Type: selectedCartItem?.orderType,
              rate: rate,
              Payment_Gateway: "Razorpay",
            });
            var rpOrderId = rpOrderIdResponse?.id;

            const rpSecreats = await CommonService.getRazorPayCredentials();
            const rpCredentials = rpSecreats?.credentials;

            let newCartData = [];
            let newCartInfo: any = [{ ...selectedCartItem }];
            if (
              [orderType.chadhava, orderType.prasad]?.includes(
                selectedCartItem?.orderType,
              )
            ) {
              const singleCartData = { ...selectedCartItem };
              const selectedChadhavaPackage = getSelectedChadhvaList();
              let cartPayload = { ...singleCartData, selectedChadhavaPackage };
              newCartData.push(cartPayload);
              newCartInfo = newCartData;
            }
            const priceConversionRate =
              priceConversionState.priceConversionRate || {};

            let prasadDelivaryAddress: any = null;
            //      (isPrasad && cartInfo[0]?.orderType === orderType.puja) && selectedAddressInCart
            //     ? selectedAddressInCart
            //     : isPrasad && cartInfo[0]?.orderType === orderType.prasad ? selectedAddressInCart : null;

            if (selectedAddressInCart) {
              if (
                isPrasad &&
                (selectedCartItem?.orderType === orderType.puja ||
                  selectedCartItem?.orderType === orderType.pujaPackage)
              ) {
                prasadDelivaryAddress = selectedAddressInCart;
              } else if (selectedCartItem?.orderType === orderType.prasad) {
                prasadDelivaryAddress = selectedAddressInCart;
              } else {
                prasadDelivaryAddress = null;
              }
            } else {
              prasadDelivaryAddress = null;
            }
            const couponData =
              couponApplyResponse?.isApplied && couponApplyResponse?.couponData
                ? couponApplyResponse.couponData
                : null;
            const deviceDetails = {
              ...getDeviceInfo(),
              ip: priceConversionState?.priceConversionRate?.clientIp ?? "",
            };
            // const orderValueInrPrice = isOverseas && selectedCartItem?.orderType === orderType.chadhava ? getChadhavaFinalPaymentValue()  : orderValue
            await dispatch(
              placeOrderAction(
                newCartInfo,
                userInfo,
                prasadDelivaryAddress,
                orderValue,
                transectionId,
                orderId,
                rpOrderId,
                priceBreakup,
                isPrasad,
                isOverseas,
                rate,
                currencySymbols,
                currencyCode,
                orderValueOv,
                couponData,
                deviceDetails,
              ),
            );
            if (rpOrderId && rpCredentials) {
              // const oderId = rpOrderId;
              cartTrackingRef.current.paymentStarted = true;
              const options = {
                key: rpCredentials.KEY,
                key_secreat: rpCredentials.SECRET,
                order_id: rpOrderId,
                amount: razorPayAmount.toString(),
                name: "Temple Dekho",
                description: "",
                image: templeLogo,
                handler: function (response: any) {
                  if (
                    response.razorpay_payment_id &&
                    response.razorpay_payment_id.length > 0
                  ) {
                    cartTrackingRef.current.paymentSuccess = true;

                    if (couponApplyResponse.isApplied) {
                      const couponData: any = couponApplyResponse.couponData;
                      const userPhNo = userInfo.phoneNumber;
                      dispatch(
                        updateCouponsUsageAction(
                          couponData.couponCode,
                          userPhNo,
                        ),
                      );
                    }
                    dispatch(setOrderList([]));
                    // dispatch(emptyCartAction());
                    dispatch(
                      removeItemFromCartAction(
                        userInfo.phoneNumber,
                        selectedCartItem?.cartId,
                      ),
                    );
                    // setOrderResultDetails(orderId);
                    // setOrderCreatedScreen(true);

                    let successMessage = "";
                    if (selectedCartItem?.orderType === orderType.prasad) {
                      successMessage = `${t(
                        LOCALIZATION.Thank_You_Payment_Of,
                      )} ₹ ${Math.round(getChadhavaFinalPaymentValue())}  ${t(
                        LOCALIZATION.Has_Been_Received,
                      )}`;
                    } else {
                      successMessage = `${t(
                        LOCALIZATION.Thank_You_Payment_Of,
                      )} ${currencySymbols}${
                        isOverseas &&
                        selectedCartItem?.orderType === orderType.chadhava
                          ? getChadhavaFinalPaymentValue()
                          : isOverseas &&
                              selectedCartItem?.orderType !== orderType.chadhava
                            ? formatToTwoFractionalDigits(
                                calculateOverSeasPrice(orderValue, rate),
                              )
                            : orderValue
                      }  ${t(LOCALIZATION.Has_Been_Received)}`;
                    }

                    let _cartItems = newCartInfo.map((item: any) => ({
                      item_id: item?.cartId,
                      price: isOverseas
                        ? item?.priceInfo?.finalPriceOv
                        : item?.priceInfo?.finalPrice || 0,
                      quantity: getOrderQuantity(item?.orderType, item),
                      item_name: getOrderDisplayName(item),
                    }));
                    // Track purchase event
                    trackPurchase({
                      transaction_id: response.razorpay_payment_id,
                      value: razorPayAmount.toString(),
                      currency: currencyCode ?? "INR",
                      items: _cartItems,
                    });

                    navigate("/success", {
                      state: {
                        type: "payment",
                        title: t(LOCALIZATION.Payment_Successful),
                        message: successMessage,
                        orderValue: isOverseas
                          ? formatToTwoFractionalDigits(
                              calculateOverSeasPrice(orderValue, rate),
                            )
                          : orderValue,
                        orderId,
                        transectionId,
                        priceBreakup,
                        orderType: selectedCartItem?.orderType,
                        razorpay_payment_id: response.razorpay_payment_id,
                        isPrasad,
                        isOverseas,
                        rate,
                        currencySymbols,
                        currencyCode,
                        orderValueOv,
                        orderData: selectedCartItem,
                        userInfo: userInfo,
                      },
                    });
                  } else {
                    //setBookingFailedPopUp(true);
                    navigate("/error", {
                      state: {
                        message: `Sorry for the trouble! Something went wrong while booking. Please try again in a little while. If you've already made the payment, just wait a few minutes—your order should confirm automatically.`,
                      },
                    });
                  }
                },
                prefill: {
                  name:
                    userPersonalInfo.firstName +
                    " " +
                    userPersonalInfo.lastName,
                  email: userPersonalInfo.email,
                  contact: userInfo.phoneNumber,
                },
                notes: {
                  address: selectedAddressInCart ?? priceConversionRate ?? "",
                },
                theme: {
                  color: "#F37254",
                },
                modal: {
                  escape: false,
                  ondismiss: function () {
                    fireCartAbandon("payment_cancelled");
                  },
                },
              };

              var pay = new (window as any).Razorpay(options);

              pay.on("modal.closed", () => {
                fireCartAbandon("payment_cancelled");
              });

              pay.on("payment.failed", function (response: any) {
                trackCleavertapEvent(ANALYTICS_EVENTS.Payment_Failed, {
                  User_ID: userInfo?.id ?? "Guest User",
                  Cart_ID: selectedCartItem?.cartId,
                  Order_ID: selectedCartItem.orderType ?? "",
                  Transaction_ID: transectionId,
                  Currency: currencyCode,
                  Failure_Code: response?.error?.code ?? "",
                  Failure_Reason: response?.error?.reason ?? "",
                  Failure_Message: response?.error?.description ?? "",
                  Payment_Method: response?.error?.source ?? "",
                  Amount: razorPayAmount.toString(),
                  rate: rate,
                });
              });
              pay.open();
            }
          },
        );
      } catch (error) {
        console.log("Error:", error);
        setBookingFailedPopUp(true);
      }

      return true;
    }
  };

  // useEffect(() => {
  //   if (couponCodeData) {
  //     checkValidityOfcoupon();
  //     // setIsPackageCouponCode(true);
  //   }
  // }, [couponCodeData]);

  const getSelectedChadhvaList = () => {
    return (
      selectedCartItem?.selectedChadhavaPackage?.filter(
        (item: any) => item?.count > 0,
      ) || []
    );
  };

  const checkValidityOfcoupon = async (couponCodeData: any) => {
    if (couponCodeData) {
      try {
        let payload;

        if (selectedCartItem.orderType === orderType.chadhava) {
          payload = {
            couponCode: couponCodeData,
            userPhoneNo: userInfo?.phoneNumber,
            templeId: templeDetails?.id,
            orderType: selectedCartItem.orderType,
            chadhavaList: getSelectedChadhvaList()?.map((item: any) => {
              return {
                id: item?.id,
                count: item?.count,
              };
            }),
          };
        } else {
          payload = {
            couponCode: couponCodeData,
            userPhoneNo: userInfo?.phoneNumber,
            templeId: templeDetails?.id,
            pujaId: pujaDetails?.pujaId,
            packageId: selectedCartItem?.selectedPujaPackage?.packageId,
            orderType: selectedCartItem.orderType,
            isOverseas: isOverseas,
            isPrasad: isPrasad,
          };
        }

        const couponValRes2 =
          await CouponService.verifyCouponAndGetPrice(payload);

        if (couponValRes2.isError === false && couponValRes2.finalPrice) {
          setCouponApplyResponse({
            ...couponApplyResponse,
            isValid: true,
            isError: false,
            actualPujaPrice: couponValRes2.actualPujaPrice,
            finalPrice: couponValRes2.finalPrice,
            couponData: couponValRes2.couponData,
            discount: couponValRes2.discount,
            gst: couponValRes2.gst,
            priceBreakup: couponValRes2.priceBreakup,
            isApplied: true,
            corePrice: couponValRes2?.corePrice ?? 0,
          });
          setCouponPopUp(false);
        } else {
          setCouponApplyResponse({
            ...couponApplyResponse,
            isValid: false,
            isApplied: false,
            isError: true,
            errorDetails: "Invalid coupon applied",
          });
        }
      } catch (err: any) {
        setCouponApplyResponse({
          ...couponApplyResponse,
          isApplied: false,
          isError: true,
          errorDetails: "Invalid coupon applied",
        });
      }
    }
  };

  const navigateToAddressScreen = () => {
    navigate("/profile/address");
  };

  const navigateToAddMembersScreen = () => {
    navigate("/checkoutV2/addDevotee");
  };

  const navigateToLoginScreen = () => {
    // set the redirect uri
    const _cartId = selectedCartItem?.cartId;
    let redirectPath = `/checkoutV2/reviewCart${
      _cartId ? `?cartId=${_cartId}` : ""
    }`;
    // selectedCartItem
    localStorage.setItem(LOCALSTORAGE_KEY.REDIRECTURL, redirectPath);
    navigate("/login?navigatedFromCheckout=true");
  };

  useEffect(() => {
    if (cartInfo?.length > 0 && selectedCartItem?.whatsAppNumber) {
      let analyticsData: any = {
        dateUTC: getDateNowInUtc(),
        key: "puja_cart_view_opened",
        eventData: {
          applicationType: "Web",
          userName: "",
        },
        count: 0,
      };

      analyticsData = { ...analyticsData, cartInfo: cartInfo };
      analyticsData["eventData"]["whatsAppNumber"] =
        `${selectedCartItem?.whatsAppNumberdialCode}${selectedCartItem?.whatsAppNumber}`;

      let user: any = localStorage.getItem("userInfo");
      let userData = null;
      if (user && user !== "undefined" && user !== "null") {
        userData = JSON.parse(user);
      }

      if (userData) {
        analyticsData.eventData.userName = userData?.personalInfo?.firstName;
        analyticsData["eventData"]["userId"] = userData?.id;
        analyticsData["eventData"]["phoneNumber"] = userData?.phoneNumber;
      } else {
        analyticsData.eventData.userName = "Guest User";
      }
      dispatch(addAnalytics(analyticsData));
    }

    return () => {};
  }, [cartInfo]);

  useEffect(() => {
    if (selectedCartItem && selectedCartItem?.membersData.length === 0) {
      navigateToAddMembersScreen();
    }
  }, [selectedCartItem]);

  // page View

  useEffect(() => {
    if (!selectedCartItem?.cartId) return;
    pageStartTimeRef.current = performance.now();
    return () => {
      if (!pageStartTimeRef.current) return;
      const duration = performance.now() - pageStartTimeRef.current;
      const timeOnPageSec = Math.round(duration / 1000);
      const cartPayload = selectedCartItem;
      const _priceValue = isOverseas
        ? truncateToTwoDecimals(
            (cartPayload?.priceInfo?.finalPrice ?? 0) * rate,
          )
        : cartPayload?.priceInfo?.finalPrice;
      const analyticsPayload = {
        User_ID: userInfo?.id ?? "Guest User",
        Cart_ID: selectedCartItem?.cartId,
        Item_Type: cartPayload?.orderType,
        Item_ID: cartPayload?.pujaDetails?.pujaNameKey ?? "",
        Item_Name:
          cartPayload?.pujaDetails?.pujaName ??
          cartPayload?.templeDetails?.chadhavaTitle ??
          "",
        Temple_ID: cartPayload?.templeDetails?.nameKey ?? "",
        Temple_Name: cartPayload?.templeDetails?.personalInfo?.name ?? "",
        Price: _priceValue ?? 0,
        Quantity: getOrderQuantityClertap(cartPayload),
        Currency:
          priceConversionState?.priceConversionRate?.currencyCode ?? "INR",
        Cart_Size: cartInfo?.length,
        Cart_Value: isOverseas
          ? truncateToTwoDecimals(getTotalCartPrice(cartInfo) * rate)
          : (getTotalCartPrice(cartInfo) ?? 0),
        IsOverseas: isOverseas,
        rate: rate ?? 1,
        IsPrasad: cartPayload?.isPrasad ?? false,
        IsSubscribed: cartPayload?.isSubscribed ? true : false,
        Time_on_Cart_Screen_Seconds: timeOnPageSec,
      };
      trackCleavertapEvent(ANALYTICS_EVENTS.Cart_Viewed, analyticsPayload);
    };
  }, [selectedCartItem?.cartId]);

  useEffect(() => {
    const resetTimer = () => {
      if (cartTrackingRef.current.paymentStarted) return;

      // clear old timer
      if (cartTimerRef.current) {
        clearTimeout(cartTimerRef.current);
      }

      // start new timer
      cartTimerRef.current = setTimeout(() => {
        fireCartAbandon("inactivity");
      }, CART_INACTIVITY_TIMEOUT);
    };

    ["click", "scroll", "keydown", "mousemove", "touchstart"].forEach((event) =>
      window.addEventListener(event, resetTimer),
    );

    resetTimer();

    return () => {
      ["click", "scroll", "keydown", "mousemove", "touchstart"].forEach(
        (event) => window.removeEventListener(event, resetTimer),
      );

      if (cartTimerRef.current) {
        clearTimeout(cartTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      fireCartAbandon("navigated_away");
    };
  }, [location.pathname]);

  useEffect(() => {
    if (!selectedCartItem?.cartId) return;
    const current = selectedCartItem?.cartId;

    if (
      prevCartRef.current &&
      prevCartRef.current !== current &&
      !cartTrackingRef.current.paymentSuccess
    ) {
      fireCartAbandon("cart_changed");
    }

    prevCartRef.current = current;
    cartTrackingRef.current.abandonFired = false;
  }, [selectedCartItem?.cartId]);

  const handleSetCouponCodeData = (event: any) => {
    setCouponCodeData(event);
  };

  const updateCart = (cartPayload: any) => {
    let newCartData = [];
    newCartData.push(cartPayload);
    dispatch(updateCartAction(newCartData));
    dispatch(
      addAndUpdateCartItem(
        userInfo?.phoneNumber,
        newCartData[0]?.cartId,
        newCartData[0],
      ),
    );
  };

  const handleIncrement = (item: any) => {
    const singleCartData = selectedCartItem;
    if (
      singleCartData?.orderType === orderType.prasad &&
      item?.count === 0 &&
      item?.packages?.length
    ) {
      setIsPrasadPkgOpen(true);
      setSelectedPrasadItem(item);
      return;
    }

    if (singleCartData?.orderType === orderType.chadhava) {
      const selectedChadhavaPackage =
        singleCartData.selectedChadhavaPackage.map((chadhava: any) => {
          if (chadhava.id === item.id) {
            const updatedCount = chadhava.count + 1;
            return { ...chadhava, count: updatedCount };
          } else {
            return chadhava;
          }
        });

      let cartPayload = { ...singleCartData, selectedChadhavaPackage };
      updateCart(cartPayload);
    } else if (singleCartData?.orderType === orderType.prasad) {
      const selectedPrasadPackage = singleCartData.selectedPrasadPackage.map(
        (prasad: any) => {
          if (prasad.id === item.id) {
            const updatedCount = prasad.count + 1;
            const selPkg = prasad?.packages?.find(
              (_pkg: any) => _pkg.packageId === prasad?.selectedPackageId,
            );
            if (
              singleCartData?.orderType === orderType.prasad &&
              selPkg &&
              selPkg?.maxLimit &&
              updatedCount > Number(selPkg.maxLimit)
            ) {
              setIsOverLimit(true);
              return prasad;
            }
            return { ...prasad, count: updatedCount };
          } else {
            return prasad;
          }
        },
      );

      let cartPayload = { ...singleCartData, selectedPrasadPackage };
      updateCart(cartPayload);
    }
  };

  // else if(singleCartData?.orderType===orderType.prasad){
  //   const selectedPrasadPackage = singleCartData.selectedPrasadPackage.map(
  //     (prasad: any) => {
  //       if (prasad.id === item.id) {
  //         const updatedCount = prasad.count + 1;
  //         return { ...prasad, count: updatedCount };
  //       } else {
  //         return prasad;
  //       }
  //     }
  //   );

  //   let cartPayload = { ...singleCartData, selectedPrasadPackage };
  //   updateCart(cartPayload);
  // }

  // };

  // const handleDecrement = (item: any) => {
  //   const singleCartData = cartInfo[0];
  //   const selectedChadhvaList = singleCartData.selectedChadhvaList.map(
  //     (chadhava: any) => {
  //       if (chadhava.id === item.id) {
  //         const updatedCount = chadhava.count > 0 ? chadhava.count - 1 : 0;
  //         return { ...chadhava, count: updatedCount };
  //       } else {
  //         return chadhava;
  //       }
  //     }
  //   );

  //   let cartPayload = { ...singleCartData, selectedChadhvaList };

  //   updateCart(cartPayload);
  // };

  const handleDecrement = (item: any) => {
    const singleCartData = selectedCartItem;

    if (singleCartData?.orderType === orderType.chadhava) {
      let selectedChadhavaPackage = singleCartData.selectedChadhavaPackage.map(
        (chadhava: any) => {
          if (chadhava.id === item.id) {
            const updatedCount = chadhava.count > 0 ? chadhava.count - 1 : 0;
            return { ...chadhava, count: updatedCount };
          } else {
            return chadhava;
          }
        },
      );
      let addOnChadhavaItems = [...(singleCartData?.addOnChadhavaItems ?? [])];
      if (item?.count === 1) {
        addOnChadhavaItems = [...addOnChadhavaItems, { ...item, count: 0 }];
        selectedChadhavaPackage =
          singleCartData?.selectedChadhavaPackage.filter(
            (itm: any) => itm.id !== item.id,
          );
      }

      const chadhavaList = selectedChadhavaPackage
        ? selectedChadhavaPackage?.filter((item: any) => item?.count > 0)
        : [];

      if (chadhavaList.length === 0) {
        setShowConfirmationModal(true);
      } else {
        let cartPayload = {
          ...singleCartData,
          selectedChadhavaPackage,
          addOnChadhavaItems,
        };
        updateCart(cartPayload);
      }
    } else if (singleCartData?.orderType === orderType.prasad) {
      let selectedPrasadPackage = singleCartData.selectedPrasadPackage.map(
        (prasad: any) => {
          // if (prasad.id === item.id) {
          //   const updatedCount = prasad.count > 0 ? prasad.count - 1 : 0;
          //   return { ...prasad, count: updatedCount };
          // } else {
          //   return prasad;
          // }
          if (prasad.id === item.id) {
            const updatedCount = prasad.count > 0 ? prasad.count - 1 : 0;
            if (
              singleCartData?.orderType === orderType.prasad &&
              updatedCount === 0 &&
              prasad?.selectedPackageId
            ) {
              return {
                ...prasad,
                count: updatedCount,
                selectedPackageId: null,
              };
            }
            return { ...prasad, count: updatedCount };
          } else {
            return prasad;
          }
        },
      );
      let addOnPrasadItems = [...(singleCartData?.addOnPrasadItems ?? [])];
      if (item?.count === 1) {
        addOnPrasadItems = [...addOnPrasadItems, { ...item, count: 0 }];
        selectedPrasadPackage = singleCartData?.selectedPrasadPackage.filter(
          (itm: any) => itm.id !== item.id,
        );
      }

      const prasadList = selectedPrasadPackage
        ? selectedPrasadPackage?.filter((item: any) => item?.count > 0)
        : [];

      if (prasadList.length === 0) {
        setShowConfirmationModal(true);
      } else {
        let cartPayload = {
          ...singleCartData,
          selectedPrasadPackage,
          addOnPrasadItems,
        };
        updateCart(cartPayload);
      }
    }
  };

  const handleConfirmDelete = (e: any) => {
    try {
      e.preventDefault();
      dispatch(
        removeItemFromCartAction(
          userInfo?.phoneNumber,
          selectedCartItem?.cartId,
        ),
      );
      if (selectedCartItem?.orderType === orderType.chadhava) {
        navigate(`/chadhavaDetails/${templeDetails?.nameKey ?? ""}`);
      } else if (selectedCartItem?.orderType === orderType.prasad) {
        navigate(`/prasadDetails/${templeDetails?.nameKey ?? ""}`);
      } else {
        navigate("/");
      }
    } catch (err: any) {
    } finally {
      setShowConfirmationModal(false);
    }
  };
  const handleCancelDelete = () => {
    setShowConfirmationModal(false);
  };

  const handRedirectToChadhavaPage = () => {
    if (templeDetails?.id) {
      navigate("/chadhavaDetails/" + templeDetails?.nameKey);
      dispatch(emptyCartAction());
    }
  };

  const handRedirectToPrasadPage = () => {
    if (templeDetails?.id) {
      navigate("/prasadDetails/" + templeDetails?.nameKey);
      dispatch(emptyCartAction());
    }
  };

  const handlePrasadCheckboxChange = (event: any) => {
    const isAddressInIndia = selectedAddressInCart?.countryCode === "IN";
    const isChecked = event.target.checked;
    if (userInfo && userInfo?.phoneNumber) {
      if (!isAddressInIndia) {
        setOutSideIndiaMessagePopup(true);
        setIsPrasad(false);
      } else {
        setIsPrasad(isChecked);

        // update Prasad selection in global cart
        let updatedPayload = {
          ...selectedCartItem,
          isPrasad: isChecked,
        };
        // dispatch(addAndUpdateCartItem(userInfo?.phoneNumber,selectedCartItem?.cartId,updatedPayload))
        updateCart(updatedPayload);
      }
    } else {
      if (!isOverseas) {
        setIsPrasad(isChecked);
        // update Prasad selection in global cart
        let updatedPayload = {
          ...selectedCartItem,
          isPrasad: isChecked,
        };
        dispatch(
          addAndUpdateCartItem(
            userInfo?.phoneNumber,
            selectedCartItem?.cartId,
            updatedPayload,
          ),
        );
        updateCart(updatedPayload);
      } else {
        setOutSideIndiaMessagePopup(true);
        setIsPrasad(false);
      }
    }
    setCouponApplyResponse({
      ...couponApplyResponse,
      isApplied: false,
      isValid: false,
    });
  };
  const handleSelectedPanditDakshina = (value: any) => {
    let inrAmount = Number(value) / rate;
    setPanditDakshina(inrAmount);
  };

  const handleDeliveryAlertClose = () => {
    setShowDeliveryAlert(false);
  };

  useEffect(() => {
    if (!selectedAddressInCart && userPersonalInfo) {
      // setShowDeliveryAlert(true)
    }
  }, [selectedAddressInCart]);

  const handleAddChadhava = (item: any) => {
    const singleCartData = selectedCartItem;
    if (
      singleCartData?.orderType === orderType.prasad &&
      item?.count === 0 &&
      item?.packages?.length
    ) {
      setIsPrasadPkgOpen(true);
      setSelectedPrasadItem(item);
      return;
    }
    if (singleCartData.orderType === orderType.chadhava) {
      const selectedChadhavaPackage = [
        ...singleCartData.selectedChadhavaPackage,
        { ...item, count: 1 },
      ];
      const addOnChadhavaItems = singleCartData?.addOnChadhavaItems?.filter(
        (itm: any) => itm.id !== item.id,
      );
      let cartPayload = {
        ...singleCartData,
        selectedChadhavaPackage,
        addOnChadhavaItems,
      };
      updateCart(cartPayload);
    } else if (singleCartData.orderType === orderType.prasad) {
      const selectedPrasadPackage = [
        ...singleCartData.selectedPrasadPackage,
        { ...item, count: 1 },
      ];
      const addOnPrasadItems = singleCartData?.addOnPrasadItems?.filter(
        (itm: any) => itm.id !== item.id,
      );
      let cartPayload = {
        ...singleCartData,
        selectedPrasadPackage,
        addOnPrasadItems,
      };
      updateCart(cartPayload);
    }
  };

  const handleSelectPrasadPkg = (pkgId: any, selectedPrasad: any) => {
    const singleCartData = selectedCartItem;
    const updatedCount = 1;
    const selPkg = selectedPrasad?.packages?.find(
      (_pkg: any) => _pkg.packageId === pkgId,
    );
    if (selPkg && selPkg?.maxLimit && updatedCount > Number(selPkg.maxLimit)) {
      setIsOverLimit(true);
      return;
    }

    let newItem: any = { ...selectedPrasad };
    newItem.count = 1;
    newItem.selectedPackageId = pkgId;
    newItem.priceInfo = selPkg?.priceInfo ?? null;
    const addOnPrasadItems = singleCartData?.addOnPrasadItems?.filter(
      (prasad: any) => prasad?.id !== selectedPrasad?.id,
    );

    let cartPayload = {
      ...singleCartData,
      selectedPrasadPackage: [
        ...selectedCartItem.selectedPrasadPackage,
        newItem,
      ],
      addOnPrasadItems,
    };
    updateCart(cartPayload);
  };

  const handleChadhavaPlanSelection = (plan: any) => {
    updateCart({
      ...selectedCartItem,
      currentSubscriptionPlan: plan,
      subscriptionId: plan?.subscriptionId,
    });
  };

  const handlePujaPlanSelection = (plan: any) => {
    updateCart({
      ...selectedCartItem,
      currentSubscriptionPlan: plan,
      subscriptionId: plan?.subscriptionId,
    });
  };

  const fireCartAbandon = (reason: string) => {
    if (cartTrackingRef.current.abandonFired) return;
    if (cartTrackingRef.current.paymentSuccess) return;
    if (!selectedCartItem?.cartId) return;

    cartTrackingRef.current.abandonFired = true;
    const cartPayload = selectedCartItem;
    const _priceValue = isOverseas
      ? truncateToTwoDecimals((cartPayload?.priceInfo?.finalPrice ?? 0) * rate)
      : cartPayload?.priceInfo?.finalPrice;
    const payload = {
      Abandonment_Reason: reason,
      Time_Since_Add_Minutes: Date.now() - cartTrackingRef.current.startedAt,
      User_ID: userInfo?.id ?? "Guest User",
      Cart_ID: selectedCartItem?.cartId,
      Item_Type: cartPayload?.orderType,
      Item_ID: cartPayload?.pujaDetails?.pujaNameKey ?? "",
      Item_Name:
        cartPayload?.pujaDetails?.pujaName ??
        cartPayload?.templeDetails?.chadhavaTitle ??
        "",
      Temple_ID: cartPayload?.templeDetails?.nameKey ?? "",
      Temple_Name: cartPayload?.templeDetails?.personalInfo?.name ?? "",
      Price: _priceValue ?? 0,
      Quantity: getOrderQuantityClertap(cartPayload),
      Currency:
        priceConversionState?.priceConversionRate?.currencyCode ?? "INR",
      Cart_Size: cartInfo?.length,
      Cart_Value: isOverseas
        ? truncateToTwoDecimals(getTotalCartPrice(cartInfo) * rate)
        : (getTotalCartPrice(cartInfo) ?? 0),
      IsOverseas: isOverseas,
      rate: rate ?? 1,
      IsPrasad: cartPayload?.isPrasad ?? false,
      IsSubscribed: cartPayload?.isSubscribed ? true : false,
    };

    trackCleavertapEvent(ANALYTICS_EVENTS.Cart_Abandoned, payload);
  };

  return (
    <div>
      {cartInfo && cartInfo.length > 0 ? (
        <ReviewCartView
          userDetails={userInfo}
          userPersonalInfo={userPersonalInfo}
          priceBreakup={priceBreakupData}
          pujaDetails={pujaDetails}
          templeDetails={templeDetails}
          memberDetails={memberDetails}
          selectedAddressDetails={selectedAddressInCart}
          chooseAddressBox={chooseAddressBox}
          setChooseAddressBox={setChooseAddressBox}
          changeDeliverytAddress={changeDeliverytAddress}
          editPujaOptions={() =>
            editPujaOptions(selectedCartItem ? selectedCartItem : {})
          }
          placeOrder={handlePlaceOrderV2}
          setOrderCreatedScreen={setOrderCreatedScreen}
          orderCreatedScreen={orderCreatedScreen}
          orderResultDetails={orderResultDetails}
          cartDetails={selectedCartItem ? selectedCartItem : {}}
          clearCart={clearCart}
          errorPopup={errorPopup}
          setErrorPopUp={setErrorPopUp}
          bookingFailedPopup={bookingFailedPopup}
          setBookingFailedPopUp={setBookingFailedPopUp}
          couponPopup={couponPopup}
          setCouponPopUp={setCouponPopUp}
          setCouponCodeData={handleSetCouponCodeData}
          couponCodeData={couponCodeData}
          checkValidityOfcoupon={checkValidityOfcoupon}
          couponApplyResponse={couponApplyResponse}
          setCouponApplyResponse={setCouponApplyResponse}
          navigateToAddressScreen={navigateToAddressScreen}
          navigateToAddMembersScreen={navigateToAddMembersScreen}
          navigateToLoginScreen={navigateToLoginScreen}
          setPriceQuoteForPuja={setPriceQuoteForPuja}
          allActiveCoupons={allActiveCoupons}
          chadhavaList={chadhavaList}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          handRedirectToChadhavaPage={handRedirectToChadhavaPage}
          setPanditCustomeDakshina={handleSelectedPanditDakshina}
          setPanditDakshina={setPanditDakshina}
          previousPriceData={previousPriceData}
          getChadhavaTotalValue={getChadhavaTotalValue}
          getOverSeasPriceByRateText={getOverSeasPriceByRateText}
          currencySign={currencySign}
          handlePrasadCheckboxChange={handlePrasadCheckboxChange}
          setOutSideIndiaMessagePopup={setOutSideIndiaMessagePopup}
          outSideIndiaMessagePopup={outSideIndiaMessagePopup}
          isPrasad={isPrasad}
          panditDakshina={panditDakshina}
          setIsPrasad={setIsPrasad}
          isCountryDisabledForBooking={
            [
              orderType.chadhava,
              orderType.puja,
              orderType.pujaPackage,
              orderType.chadhavaPackage,
            ]?.includes(selectedCartItem?.orderType)
              ? (priceConversionState?.isCountryDisabled ?? false)
              : countryCode === "IN"
                ? false
                : true
          }
          isOverseas={isOverseas}
          getChadhavaFinalPaymentValue={getChadhavaFinalPaymentValue}
          rate={rate}
          getSymbolWithPrice={getSymbolWithPrice}
          handRedirectToPrasadPage={handRedirectToPrasadPage}
          handleAddChadhava={handleAddChadhava}
          isPrasadPkgOpen={isPrasadPkgOpen}
          setIsPrasadPkgOpen={setIsPrasadPkgOpen}
          selectedPrasadItem={selectedPrasadItem}
          setSelectedPrasadItem={setSelectedPrasadItem}
          handleSelectPrasadPkg={handleSelectPrasadPkg}
          selectedChadhavaSubscription={selectedChadhavaSubscription}
          subscriptionChadhavaAggPrice={subscriptionChadhavaAggPrice}
          handleChadhavaPlanSelection={handleChadhavaPlanSelection}
          selectedPujaSubscription={selectedPujaSubscription}
          handlePujaPlanSelection={handlePujaPlanSelection}
          singlePujaPrice={singlePujaPrice}
        />
      ) : (
        <CartNoItem />
      )}
      <Dialog
        className="OrderResult"
        onClose={() => {
          setOrderCreatedScreen(false);
          navigate("/home");
        }}
        open={orderCreatedScreen}
      >
        <Box className="successCard">
          <Box className="successIcon">
            <img src={successIcon} alt="" />
          </Box>
          <Typography mt="30px">Your order Created Successfully</Typography>
          <Typography>
            {t(LOCALIZATION.Order_id)} : {orderResultDetails}
          </Typography>
          <Button
            variant="outlined"
            onClick={() => {
              setOrderCreatedScreen(false);
              navigate("/home");
            }}
          >
            Ok
          </Button>
        </Box>
      </Dialog>
      <Dialog
        className="errorMsg"
        onClose={() => setBookingFailedPopUp(false)}
        open={bookingFailedPopup}
      >
        <Box className="errorCard">
          <Box className="errorIcon">
            <img src={errorIcon} alt="" />
          </Box>
          <Typography>{t(LOCALIZATION.Sorry_For_Inconvenience)}</Typography>
          <Button onClick={() => setBookingFailedPopUp(false)}>
            {t(LOCALIZATION.OK)}
          </Button>
        </Box>
      </Dialog>
      <>
        <Dialog
          className="deleteConfirmModal"
          open={showConfirmationModal}
          onClose={handleCancelDelete}
        >
          <DialogTitle className="deleteConfirmModal">
            Confirm Deletion
          </DialogTitle>
          <Divider className="titleDivider" />
          <DialogContent>
            <Typography sx={{ fontWeight: 500, color: "#6e6e6e" }}>
              Do you really want to clear everything from your cart?
            </Typography>
          </DialogContent>
          <DialogActions className="confirmBtn">
            <Button
              className="confirmBtnCancel"
              onClick={handleCancelDelete}
              color="primary"
              variant="outlined"
            >
              No
            </Button>
            <Button
              className="confirmBtnDelete"
              onClick={handleConfirmDelete}
              color="primary"
              variant="contained"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </>
      <Snackbar
        open={showDeliveryAlert}
        autoHideDuration={3000} // Snackbar will disappear after 6 seconds
        onClose={handleDeliveryAlertClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleDeliveryAlertClose} severity="error">
          Prasad delivery not allowed outside India
        </Alert>
      </Snackbar>

      <BookingDateConfirmDialog
        open={bookingDateConfirmDialogOpen}
        bookingDate={bookingDateInConfirmDialog}
        newDate={newDateDateInConfirmDialog}
        onConfirm={handleBookingConfirm}
        onCancel={handleBookingCancel}
        type={selectedCartItem?.orderType}
      />
      <DelivaryWeightConfirmationDialog
        open={isOverweight}
        onCancel={() => {
          setIsOverweight(false);
        }}
        onConfirm={(e: any) => {
          setIsOverweight(false);
          handlePlaceOrder(e);
        }}
      />
      <AlertDialog
        open={isOverLimit}
        onClose={() => {
          setIsOverLimit(false);
        }}
        message={t(LOCALIZATION.Max_Prasad_Item_Message)}
      />
    </div>
  );
}

export default ReviewCartScreen;
